module.exports = "/assets/data/ebd057725e2c56edc04002da9345d3b9-NP18.data.json";